export const colors = [
    "#8884d8", "#e96e8c", "#a832a6", "#2c2c2c", "#DB5A42", "#37323E", "#DEB841", "#0D3B66", "#0B5A42"
]